<template>
  <section v-if="data">
    <pages-publications-component
      :data="data"
      :publication-categories="PublicationCategories?.data"
      :show-header="!siteNavDataIncludesPage"
    />

    <shared-logo-component />

    <nuxt-page />
  </section>
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const mainStore = useMainStore()
const route = useRoute()

// 1
const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryPublicationsPage(getPageQuery()) } } ) )

data.value = getFirstObject(data.value)

setHead(data.value)

// 2
const filterId = computed(() => route?.query?.biennialEntryId)

const { data: PublicationCategories, error: errorPublicationCategories } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPublicationCategories(getPageQuery({filterId: route?.query?.biennialEntryId})) } }
  )
}, { watch: [ filterId ]})

// 3
const siteNavDataIncludesPage = computed(() => {
  if (!mainStore.siteNavData?.items) { return false }
  return mainStore.siteNavData?.items
  return siteNavData.value?.items?.some((item: any) => item?.page === 'Publications Page')
})
</script>
